import React from 'react';
import { isAnyWorkerSource } from '@scale/shared/workerSlack/helpers';

const SlackChannelTierSources = (props: $FIXME) => {
  return (
    <>
      <div className="item-option-container">
        <label>Tier Statuses: </label>
        <div className="tier-statuses-container">
          {!isAnyWorkerSource(props.channel.tierStatuses) &&
            props.channel.tierStatuses.map((tierStatus: string) => (
              <div
                key={tierStatus}
                className={`tier-status-box-container  tier-status-box-${tierStatus}`}
              >
                <div className="tier-status-box">
                  {tierStatus === '' ? `No Tier Status` : tierStatus}
                </div>
              </div>
            ))}
          {!!isAnyWorkerSource(props.channel.tierStatuses) && (
            <div className={`tier-status-box-container  tier-status-box-level-${null}`}>
              <div className="tier-status-box">All tier statuses</div>
            </div>
          )}
        </div>
      </div>
      <style>{`
        label {
          font-weight: 500;
          padding-right: 4px;
        }
        .tier-statuses-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 300px;
          margin-left: 8px;
        }
        .tier-status-box-container {
          border-radius: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 4px;
          border: 1px solid var(--color-RemoGray50);
        }
        .tier-status-box {
          padding: 4px 12px;
          white-space: nowrap;
        }
        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default SlackChannelTierSources;
